import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RDBreadcrumbElement} from './breadcrumb-element.class';
import { RDDarkService } from '../dark.service';

@Component({
  selector: 'rd-breadcrumb',
  template: `<div class="rd-breadcrumb {{color}}BreadCrumb" [class.rdDark]="dark">
  <ng-container *ngFor="let step of data; let lastStep = last;">
    <div class="stepText" (click)="fileSelect.emit(step.file)">{{step.name}}</div>
    <div class="stepper" *ngIf="!lastStep"></div>
  </ng-container>
</div>
`,
  styles: [`.rd-breadcrumb{--main-color:#ba9e5a;--background-color:#f1f1f1;--text-color:black;display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;color:var(--text-color)}.rd-breadcrumb .stepText{padding:6px;cursor:pointer;max-width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;background-color:transparent;border-radius:15px;transition:color .4s,background-color .3s}.rd-breadcrumb .stepText:last-child{font-weight:700}.rd-breadcrumb .stepText:hover{background-color:var(--background-color);color:var(--main-color)}.rd-breadcrumb .stepper{font-weight:700;border-top:3px solid;border-right:3px solid;width:8px;height:8px;-webkit-transform:rotate(45deg);transform:rotate(45deg);margin-right:6px;border-color:var(--main-color)}.rd-breadcrumb.blueBreadCrumb{--main-color:#5a5aba}.rd-breadcrumb.greenBreadCrumb{--main-color:#72ba5a}.rd-breadcrumb.blue-lightBreadCrumb{--main-color:#5aa2ba}.rd-breadcrumb.redBreadCrumb{--main-color:#ba5a5a}.rd-breadcrumb.purpleBreadCrumb{--main-color:#a25aba}.rd-breadcrumb.orangeBreadCrumb{--main-color:#ba8a5a}.rd-breadcrumb.blackBreadCrumb{--main-color:black}.rd-breadcrumb.rdDark{--background-color:#07384c;--text-color:white}`]
})
export class RDBreadcrumbComponent implements OnInit {

  @Input() data: Array<RDBreadcrumbElement> = [];
  @Input() color = 'gold';

  @Output() fileSelect: EventEmitter<any> = new EventEmitter();

  public dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

}
